var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small"},[_c('bar',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options,"styles":{height: '300px', position: 'relative', width: '100%', 'margin-top': '10px'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }